<app-floorplan-item-details
  [extent]="extent()"
  [isExtendable]="true"
  (toggleExtendedButtonClicked)="toggleExtendedButtonClicked.emit()"
  [floorplanItem]="cableRoute()"
>
  <div data-main>
    @if (cableRouteForm) {
      <form odxForm [formGroup]="cableRouteForm" [disabled]="cableRoute().locked">
        <odx-form-field i18n-label="@@floorplan.details.cableRoute.form.name.label" label="Name">
          <input
            formControlName="name"
            odxFormFieldControl
            i18n-placeholder="@@floorplan.details.cableRoute.form.name.placeholder"
            placeholder="Name"
          />
        </odx-form-field>
      </form>
    }
    <app-reference-measurement-item-length [floorplanItem]="cableRoute()"></app-reference-measurement-item-length>
  </div>
  <div data-extended>
    <div odxLayout="flex" class="flex-column">
      <h5 i18n="@@floorplan.details.cableRoute.extendedNotes.title" class="odx-title-5">Spezifikationen</h5>
      @if (cableRouteForm) {
        <form odxForm [formGroup]="cableRouteForm" [disabled]="cableRoute().locked">
          <odx-checkbox
            class="checkbox-padding"
            formControlName="constructionKit"
            i18n="@@floorplan.details.cableRoute.form.constructionKit"
          >
            Bausatz
          </odx-checkbox>
          <odx-form-field i18n-label="@@floorplan.details.wire.form.length.label.deprecated" label="Länge (Deprecated)">
            <input
              formControlName="scalingLength"
              odxFormFieldControl
              i18n-placeholder="@@floorplan.details.wire.form.scalingLength.placeholder.deprecated"
              placeholder="Länge"
              [odxTooltip]="tooltipTextDeprecatedLength"
            />
          </odx-form-field>
        </form>
      }
    </div>
  </div>
</app-floorplan-item-details>
